import { render } from "./ComEditButton.vue?vue&type=template&id=25bfd98e&ts=true"
import script from "./ComEditButton.vue?vue&type=script&lang=ts"
export * from "./ComEditButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__